import { useSelector } from 'react-redux';
import { RootState } from '../state/store';

export const useUser = () => {
  const user = useSelector((state: RootState) => state.profile);
  if (!user) {
    throw new Error('User not active. Login');
  }
  return user;
};
